import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, errMsg } from "../lib/api";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

export default function ResetPassword() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const [password, setPassword] = useState("");
  const [step, setStep] = useState(1);
  const [busy, setBusy] = useState(false);

  const requestCode = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setToken(data.reset_token || "");
      setStep(2);
      toast.success(data.reset_token ? "Reset code generated — it's pre-filled below" : data.message);
    } catch (err) {
      toast.error(errMsg(err));
    }
    setBusy(false);
  };

  const doReset = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      toast.success("Password reset — sign in with your new password");
      nav("/login");
    } catch (err) {
      toast.error(errMsg(err));
    }
    setBusy(false);
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16 fade-up">
      <p className="text-xs tracking-[0.2em] uppercase font-bold text-[#c8102e] mb-2">Account help</p>
      <h1 className="font-display text-3xl font-bold text-[#1a1f36] mb-6">Reset your password</h1>
      {step === 1 ? (
        <form onSubmit={requestCode} className="space-y-4">
          <div>
            <Label htmlFor="email">Your account email</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="reset-email" />
          </div>
          <Button type="submit" disabled={busy} className="w-full sw-red hover:bg-red-700 text-white font-semibold" data-testid="reset-request-btn">
            {busy ? "Working…" : "Get reset code"}
          </Button>
        </form>
      ) : (
        <form onSubmit={doReset} className="space-y-4">
          <div>
            <Label htmlFor="token">Reset code</Label>
            <Input id="token" value={token} onChange={(e) => setToken(e.target.value)} required data-testid="reset-token" />
          </div>
          <div>
            <Label htmlFor="pw">New password</Label>
            <Input id="pw" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8} placeholder="Min 8 characters" data-testid="reset-new-password" />
          </div>
          <Button type="submit" disabled={busy} className="w-full sw-red hover:bg-red-700 text-white font-semibold" data-testid="reset-submit-btn">
            {busy ? "Resetting…" : "Reset password"}
          </Button>
        </form>
      )}
    </div>
  );
}
